import { render } from "./EditCar.vue?vue&type=template&id=32b6b232&scoped=true"
import script from "./EditCar.vue?vue&type=script&lang=js"
export * from "./EditCar.vue?vue&type=script&lang=js"

import "./EditCar.vue?vue&type=style&index=0&id=32b6b232&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b6b232"]])

export default __exports__